import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { EstablishmentService } from '../../establishment.service';
import { PurchaseActorScopeEnum } from '../../../../../../core/models/purchase-actor.model';
import { ENUM_PERMISSIONS } from '../../../../../../core/enums/permission.enum';

/**
 * Onglet « Acteurs achats » de la fiche établissement (PRED-3139) : configuration prioritaire
 * sur celle du tenant, avec indication visuelle des acteurs hérités de la configuration client.
 * Remplace l'ancien écran dédié (arbre + panneau maison) par le composant partagé
 * `purchase-actors-panel` — calque de `establishment-details-supervision`.
 *
 * Deep-link dashboard (incident FAMILY_WITHOUT_ACTOR, leftover T15/T16) : route
 * `establishment/:id/validators/:id` (2e `:id` = famille) — cf.
 * `management-routing.module.ts` et `dashboard.component.ts#seeDetails`.
 */
@Component({
  selector: 'establishment-details-validators-component',
  template: `
    <purchase-actors-panel
      *ngIf="establishment"
      [scope]="scope"
      [establishment]="establishment"
      [modifyPermissions]="modifyPermissions"
      [preselectCategoryId]="preselectCategoryId"
    ></purchase-actors-panel>
  `,
})
export class EstablishmentDetailsValidatorsComponent implements OnInit, OnDestroy {
  scope = PurchaseActorScopeEnum.ESTABLISHMENT;
  modifyPermissions = [ENUM_PERMISSIONS.UPDATE_ESTABLISHMENT];
  establishment: { _id: string; label: string; technicalIdentifier?: string };
  preselectCategoryId: string;

  private subscription = new Subscription();

  constructor(
    private establishmentService: EstablishmentService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    // Route `validators/:id` (cf. management-routing.module.ts) : le param s'appelle `id`, pas
    // `subId` — même segment que le lien dashboard `['/management/establishment', id, 'validators', subId]`.
    this.preselectCategoryId = this.route.snapshot.paramMap.get('id') ?? undefined;
    this.subscription.add(
      this.establishmentService.entity$.subscribe(entity => {
        if (entity?._id) {
          this.establishment = {
            _id: entity._id,
            label: entity.label,
            technicalIdentifier: entity.technicalIdentifier,
          };
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
